import { Link } from "react-router-dom";
import "../App.css";

function Support() {
 const telegramLink =
  "https://t.me/snapetubepro";

const emailAddress =
  "snapetube.pro@gmail.com";
  const whatsappLink =
    "https://whatsapp.com/channel/0029VbDWVyBIiRoz7oQ8kc2Q";

  return (
    <div className="app support-page">
      <header className="page-header">
        <Link to="/" className="back-button">
          ←
        </Link>

        <div>
          <h1>Support Center</h1>
          <p>Connect with our official channels</p>
        </div>
      </header>

      <section className="support-hero-card">
        <div className="support-hero-icon">🛟</div>

        <h2>Need Help?</h2>

        <p>
          Follow our official channels for updates,
          announcements and support.
        </p>
      </section>

      <section className="support-options">
        <a
          href={whatsappLink}
          target="_blank"
          rel="noopener noreferrer"
          className="support-option-card whatsapp-support-card"
        >
          <div className="support-option-icon">W</div>

          <div className="support-option-content">
            <h3>WhatsApp Channel</h3>
            <p>Get official updates and support</p>
          </div>

          <span className="support-arrow">›</span>
        </a>

       <a
  href={telegramLink}
  target="_blank"
  rel="noopener noreferrer"
  className="support-option-card telegram-support-card"
>
  <div className="support-option-icon">✈️</div>

  <div className="support-option-content">
    <h3>Official Telegram</h3>
    <p>@snapetubepro</p>
  </div>

  <span className="support-arrow">›</span>
</a>
<a
  href={`mailto:${emailAddress}`}
  className="support-option-card email-support-card"
>
  <div className="support-option-icon">📧</div>

  <div className="support-option-content">
    <h3>Email Support</h3>
    <p>{emailAddress}</p>
  </div>

  <span className="support-arrow">›</span>
</a>
      </section>

      <section className="support-security-card">
        <h3>Security Notice</h3>

        <p>
          Never share your password, OTP, wallet key or
          personal account details with anyone.
        </p>
      </section>
    </div>
  );
}

export default Support;